import React, { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { CrisisBar } from "@/components/CrisisBar";
import { ASSETS, APP_URL } from "@/data/landing";
import { Btn } from "@/components/landing/primitives";

const NAV = [
    { label: "Program", href: "#program" },
    { label: "Assistants", href: "#coaches" },
    { label: "Science", href: "#science" },
    { label: "App", href: "#app" },
    { label: "Pricing", href: "#pricing" },
];

export const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="site-header" className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/75 backdrop-blur-xl border-b border-afwn-navy/5 shadow-sm" : "bg-transparent"}`}>
      <CrisisBar />
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={ASSETS.logo} alt="Anxiety Fix Wellness Network" className="h-14 w-14 object-contain rounded-full" />
          <span className="hidden sm:block font-heading text-2xl leading-none text-afwn-green">Anxiety&nbsp;Fix<span className="block text-[10px] tracking-[0.25em] uppercase text-afwn-slate font-body mt-0.5">Wellness Network</span></span>
        </a>
        <div className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} data-testid={`nav-link-${n.label.toLowerCase()}`} className="text-sm text-afwn-slate hover:text-afwn-green transition-colors">{n.label}</a>
          ))}
        </div>
        <div className="hidden md:block">
          <Btn href={APP_URL} data-testid="nav-cta-button" variant="primary" className="!px-6 !py-2.5 !text-sm">Start Free Trial <ArrowRight size={16} /></Btn>
        </div>
        <button data-testid="mobile-menu-toggle" onClick={() => setMenuOpen((v) => !v)} className="md:hidden p-2 text-afwn-navy" aria-label="Menu">
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>
      {menuOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-white/95 backdrop-blur-xl border-t border-afwn-navy/5 px-6 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <a key={n.href} href={n.href} onClick={() => setMenuOpen(false)} className="text-afwn-navy py-1">{n.label}</a>
          ))}
          <Btn href={APP_URL} variant="primary" className="mt-2">Start Free Trial</Btn>
        </div>
      )}
    </header>
  );
};
